export const cognitoConfig = {
  UserPoolId: process.env.REACT_APP_USER_POOL,// "us-east-1_VAHkU4GCD",
  ClientId: process.env.REACT_APP_CID // "2ee4lqosd0krjmphnl2odil9e8"

};
